import AppointmentCalendar from '../../../GwatCalendar/AppointmentCalendar';
import { Step } from './Step';

type Props = {
  isLoading: boolean;
};

const GwatSteps = ({ isLoading }: Props) => {
  return (
    <div className="px-0 md:px-10 pb-0 md:pb-10 rounded-b-md">
      <Step
        order={1}
        status="complete"
        border="green"
        title="Confirmation email"
        description={`Well done! You've taken the first & hardest step. Now the fun begins!<br class="hidden md:block" /><br class="md:hidden" /><br class="md:hidden" />In your inbox, you'll find a copy of your booking details and payment receipt.`}
        isLoading={isLoading}
      />
      <Step
        order={2}
        status="todo"
        border="dashed"
        title="Setup your gWorld account & payment plan"
        description="gWorld is your personalised portal & mobile app where you can get everything in order for your trip, access our Marketplace, Academy and meet others going to the same place. Please click on the link that has been sent to your email & take a few minutes to create your account."
        isLoading={isLoading}
      />
      <Step
        order={3}
        status="todo"
        border="dashed"
        title="Welcome call to meet your Trip Coordinator!"
        description="Choose a time that suits you to meet your new personal Trip Coordinator - a work & travel expert who’s been there and done it. They’ll be there to guide you every step of the way and help make this the best travel experience possible.</br></br>Select a time from the options below, and welcome aboard!"
        excludeUnderline
        isLoading={isLoading}
      >
        <div className="bg-[#FCFCFC] py-5 md:py-8">
          <AppointmentCalendar />
        </div>
      </Step>
      <Step
        order={4}
        status="todo"
        border="none"
        title="Get the mobile app"
        description='Access gWorld on your mobile, anytime & anywhere. Follow the instructions <span class="md:hidden">below</span><span class="hidden md:inline">to the right</span> or search the app store for Global Work & Travel.'
        excludeUnderline
        isLoading={isLoading}
      />
    </div>
  );
};

export default GwatSteps;
